module.exports = __webpack_public_path__ + "static/media/md.879bb31c.svg";